module.exports = __webpack_public_path__ + "img/70.1.e315933d.jpg";